import type { FileRouteTypes } from '@analyzer/routeTree.gen'
import type { Dictionary } from '@core/utils/types'

export const ROUTES = {
  callback: '/callback',
  signIn: '/sign-in',
  forgotPassword: '/forgot-password',
  logOut: '/logout',

  root: '/',
  workspaceRoot: '/$workspaceId',
  agent: '/$workspaceId/agent',
  agentConversation: '/$workspaceId/agent/$conversationId',
  clause: '/$workspaceId/clause',
  comparison: '/$workspaceId/comparison',
  comparisonDetail: '/$workspaceId/comparison/$comparisonId',
  comparisonText: '/$workspaceId/comparison/$comparisonId/text',
  comparisonSemantic: '/$workspaceId/comparison/$comparisonId/semantic',
  documents: '/$workspaceId/documents',
  library: '/$workspaceId/library',
  portfolio: '/$workspaceId/portfolio',
  portfolioClauses: '/$workspaceId/portfolio/clauses',
  portfolioSubmissions: '/$workspaceId/portfolio/submissions',
  submissions: '/$workspaceId/submissions',
  submissionDetail: '/$workspaceId/submissions/$submissionId',
  submissionOverview: '/$workspaceId/submissions/$submissionId/overview',
  submissionFiles: '/$workspaceId/submissions/$submissionId/files',
  submissionAttributes: '/$workspaceId/submissions/$submissionId/attributes',
  submissionAttribute:
    '/$workspaceId/submissions/$submissionId/attributes/$componentId',
  submissionControls: '/$workspaceId/submissions/$submissionId/controls',
  submissionControl:
    '/$workspaceId/submissions/$submissionId/controls/$controlId',
  submissionGenerations: '/$workspaceId/submissions/$submissionId/generations',
  submissionGeneration:
    '/$workspaceId/submissions/$submissionId/generations/$generationId',
  submissionComments: '/$workspaceId/submissions/$submissionId/comments',
  submissionRecommendations:
    '/$workspaceId/submissions/$submissionId/recommendations',
  submissionRecommendation:
    '/$workspaceId/submissions/$submissionId/recommendations/$recommendationId',
} as const satisfies Dictionary<FileRouteTypes['fullPaths']>

export type ROUTES_TYPE = typeof ROUTES

export const ROUTE_PATHS = {
  callback: '/(auth)/callback',
  signIn: '/(auth)/sign-in',
  forgotPassword: '/(auth)/forgot-password',

  root: '/_authenticated/',
  workspaceRoot: '/_authenticated/$workspaceId',
  logOut: '/logout',
  agent: '/_authenticated/$workspaceId/agent/',
  agentConversation: '/_authenticated/$workspaceId/agent/$conversationId/',
  clause: '/_authenticated/$workspaceId/clause',
  comparison: '/_authenticated/$workspaceId/comparison/',
  comparisonDetail: '/_authenticated/$workspaceId/comparison/$comparisonId/',
  comparisonText: '/_authenticated/$workspaceId/comparison/$comparisonId/text',
  comparisonSemantic:
    '/_authenticated/$workspaceId/comparison/$comparisonId/semantic',
  documents: '/_authenticated/$workspaceId/documents/',
  library: '/_authenticated/$workspaceId/library',
  portfolio: '/_authenticated/$workspaceId/portfolio/',
  portfolioClauses: '/_authenticated/$workspaceId/portfolio/clauses',
  portfolioSubmissions: '/_authenticated/$workspaceId/portfolio/submissions',
  submissions: '/_authenticated/$workspaceId/submissions/',
  submissionDetail: '/_authenticated/$workspaceId/submissions/$submissionId',
  submissionOverview:
    '/_authenticated/$workspaceId/submissions/$submissionId/overview',
  submissionFiles:
    '/_authenticated/$workspaceId/submissions/$submissionId/files',
  submissionAttributes:
    '/_authenticated/$workspaceId/submissions/$submissionId/attributes/',
  submissionAttribute:
    '/_authenticated/$workspaceId/submissions/$submissionId/attributes/$componentId',
  submissionControls:
    '/_authenticated/$workspaceId/submissions/$submissionId/controls/',
  submissionControl:
    '/_authenticated/$workspaceId/submissions/$submissionId/controls/$controlId',
  submissionGenerations:
    '/_authenticated/$workspaceId/submissions/$submissionId/generations/',
  submissionGeneration:
    '/_authenticated/$workspaceId/submissions/$submissionId/generations/$generationId',
  submissionComments:
    '/_authenticated/$workspaceId/submissions/$submissionId/comments',
  submissionRecommendations:
    '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/',
  submissionRecommendation:
    '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/$recommendationId',
} as const satisfies Record<
  keyof ROUTES_TYPE,
  Exclude<FileRouteTypes['id'], '__root__'>
>

export type ROUTE_PATHS_TYPE = typeof ROUTE_PATHS
